import React from "react";

function About_slider(data) {

    return (
        <div className="about-slider">
            <div className="container">
                <div className="row">
                    <div className="col-lg-11 col-12 m-auto">
                        <swiper-container dir="rtl" space-between="30" loop="true" effect="slide" slides-per-view="3" speed="500" pagination-el=".about-pagination" pagination-clickable="true">
                            {
                                data.data.map((slide,index) => {
                                    return (
                                        <swiper-slide key={index}>
                                            <div className="slide">
                                                <div className="img-box">
                                                    <img src={slide.photo} className="img-fluid" title={slide.title} alt={slide.title} />
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    );
                                })
                            }
                        </swiper-container>
                    </div>
                </div>
            </div>
            <div className="about-pagination"></div>
        </div>
    );

}

export default About_slider;